import { WithCleanup } from "../async/WithCleanup"

type WaitQueue = Array<() => void>

export class LockManager<T> implements LockManager<T> {
  private locks = new Map<T, WaitQueue>()
  async acquire(task_id: T): Promise<() => void> {
    return new Promise<() => void>(resolve => {
      // Get or create lock state
      let queue = this.locks.get(task_id)
      if (queue == undefined) {
        queue = []
        this.locks.set(task_id, queue)
        resolve(this.create_release_function(task_id, queue))
        return
      }

      // Lock is busy, add to wait queue
      queue.push(() => resolve(this.create_release_function(task_id, queue)))
    })
  }
  private create_release_function(task_id: T, queue: WaitQueue): () => void {
    return () => {
      const next = queue.shift()
      if (next) {
        next()
      } else {
        // Optional: Clean up empty lock states to prevent memory leaks
        this.locks.delete(task_id)
      }
    }
  }

  async schedule<G>(task_id: T, func: () => Promise<G>): Promise<G> {
    const release = await this.acquire(task_id)
    return WithCleanup(func(), release)
  }

  async *schedule_iterable<G>(
    task_id: T,
    stream: AsyncGenerator<G>
  ): AsyncGenerator<G> {
    const release = await this.acquire(task_id)
    try {
      yield* stream
    } finally {
      release()
    }
  }
}
